import React from "react";
import styles from '../styles/Header.module.css';

export default function Header({ style }) {
  return (
    <header className={styles.header} style={style}>
      <h1>𝙼𝚘𝚑𝚊𝚖𝚖𝚎𝚍 𝙰𝚋𝚍𝚞𝚕 𝙵𝚊𝚛𝚖𝚊𝚊𝚗</h1>
      <p>𝙳𝚎𝚟𝚎𝚕𝚘𝚙𝚎𝚛 & 𝙲𝚢𝚋𝚎𝚛 𝚂𝚎𝚌𝚞𝚛𝚒𝚝𝚢 𝙴𝚗𝚐𝚒𝚗𝚎𝚎𝚛</p>
    </header>
  );
}
